import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { isEmpty, uniqueId } from 'lodash';

import InformationalPopover from 'chameleon/ui-stack/ui/popovers/informational-popover';
import TextInput from 'chameleon/ui-stack/ui/forms/autocomplete-select/Input/Input';

const TextInputField = (props) => {
  const { control } = useFormContext();
  const {
    name,
    title,
    infoPopupText,
    icon,
    rules,
    onValueChange = () => {},
    inputRef = React.createRef(),
    placeholder,
    className,
  } = props;

  const inputId = uniqueId(name);

  return (
    <div className="d-block" data-test-id={props['data-test-id']}>
      <div className="h-8 d-flex flex-row items-center mb-0.8">
        <label
          className="mr-4 text-base text-gray-800 font-medium"
          htmlFor={inputId}
        >
          {title}
        </label>
        <InformationalPopover size="medium" defaultOpen={false} withPortal>
          <span
            aria-live="assertive"
            aria-label={infoPopupText}
            className="text-base leading-8"
          >
            {infoPopupText}
          </span>
        </InformationalPopover>
      </div>
      <Controller
        control={control}
        id={inputId}
        name={name}
        rules={rules}
        render={({ field }) => (
          <TextInput
            className={className}
            icon={icon}
            inputElemProps={{
              'aria-describedby': `${inputId}-description`,
              'aria-invalid': !!field.invalid,
              'aria-required': rules?.required,
              id: inputId,
              placeholder,
            }}
            inputClassName=""
            value={field.value || ''}
            onChange={(e) => {
              let formattedVal = !isEmpty(e.target.value) ? e.target.value : '';
              field.onChange(formattedVal);
              onValueChange(formattedVal);
            }}
            disableInput={field.disabled}
            name={name}
            inputRef={inputRef}
          />
        )}
      />
      {props.children && <div className="mt-4 px-2">{props.children}</div>}
    </div>
  );
};

export default TextInputField;
